<template>
	<div>
		<v-dialog
			v-model="dialog"
			max-width="600px"
			:fullscreen="$vuetify.breakpoint.xs ? true : false"
			:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					:text="text"
					:color="text ? 'white' : 'secondary'"
					class="ml-2"
					@click.stop="dialog = true"
					v-bind="attrs"
					v-on="on"
				>
					<v-icon class="mr-1">mdi-magnify</v-icon>
					検索
				</v-btn>
			</template>

			<v-card :tile="$vuetify.breakpoint.xs">
				<v-app-bar dense dark flat color="primary">
					<v-app-bar-title class="color-white">検索</v-app-bar-title>
					<v-spacer />
					<v-btn icon dark @click="dialog = false" color="white">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-app-bar>

				<v-form class="pa-2" ref="form">
					<table width="100%" class="show-dialog-table show-dialog-table--form">
						<tbody>
							<ShowDetailRecord :columnName="'事例番号'">
								<template v-slot:value>
									<v-text-field
										v-model="q.case_number_cont"
										background-color="white"
										outlined
										dense
										hide-details
									/>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :columnName="'事例名'">
								<template v-slot:value>
									<v-text-field
										v-model="q.name_cont"
										background-color="white"
										outlined
										dense
										hide-details
									/>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :columnName="'対象タイプ'">
								<template v-slot:value>
									<v-select
										v-model="q.case_type_eq"
										:items="case_types"
										item-text="name"
										item-value="id"
										background-color="white"
										outlined
										dense
										hide-details
									/>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :columnName="'対象分類'">
								<template v-slot:value>
									<v-select
										v-model="q.product_category_id_eq"
										:items="categories"
										item-text="name"
										item-value="id"
										@change="changeCategoryId"
										background-color="white"
										outlined
										dense
										hide-details
									/>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :columnName="'対象小分類'">
								<template v-slot:value>
									<v-select
										v-model="q.product_sub_category_id_eq"
										:items="setSubCategories"
										item-text="name"
										item-value="id"
										background-color="white"
										outlined
										dense
										hide-details
										:no-data-text="
											q.product_category_id_eq
												? 'データが見つかりません。'
												: '対象分類を選択してください。'
										"
									/>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :columnName="'対象品番'">
								<template v-slot:value>
									<v-text-field
										v-model="q.product_product_code_cont"
										background-color="white"
										outlined
										dense
										hide-details
									/>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :columnName="'対象品名'">
								<template v-slot:value>
									<v-text-field
										v-model="q.product_name_cont"
										background-color="white"
										outlined
										dense
										hide-details
									/>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :columnName="'作成日'">
								<template v-slot:value>
									<v-menu
										ref="createdDateRangeMenu"
										v-model="createdDateRangeMenu"
										:close-on-content-click="false"
										:return-value.sync="createdDateRange"
										transition="scale-transition"
										offset-y
										min-width="auto"
									>
										<template v-slot:activator="{ on, attrs }">
											<v-text-field
												v-model="createdDatesText"
												clearable
												outlined
												dense
												background-color="white"
												hide-details
												readonly
												v-bind="attrs"
												v-on="on"
											/>
										</template>
										<v-date-picker
											class="date-picker"
											v-model="createdDateRange"
											no-title
											scrollable
											range
											locale="ja-JP"
										>
											<div>
												<p class="text-body-2">
													2つの日付をクリックすることで範囲選択が可能です。
												</p>
												<br />
												<v-row justify="end" no-gutters>
													<v-btn text color="grey" @click="createdDateRangeMenu = false">
														キャンセル
													</v-btn>
													<v-btn
														text
														color="primary"
														@click="changeDateRange('createdDateRange', 'created_at')"
													>
														決定
													</v-btn>
												</v-row>
											</div>
										</v-date-picker>
									</v-menu>
								</template>
							</ShowDetailRecord>
						</tbody>
					</table>
				</v-form>

				<v-card-actions>
					<v-row no-gutters>
						<v-col cols="0" sm="2"></v-col>
						<v-col cols="12" sm="8">
							<v-row class="ma-0 pa-0" justify="center">
								<v-btn class="ma-1" @click="searchProblemCases" color="secondary">
									<v-icon class="mr-2">mdi-magnify</v-icon>
									検索</v-btn
								>
								<v-btn class="ma-1" @click="resetForm" outlined color="secondary">
									<v-icon class="mr-2">mdi-autorenew</v-icon>
									クリア</v-btn
								>
							</v-row>
						</v-col>
						<v-col cols="0" sm="2">
							<v-row v-if="!$vuetify.breakpoint.xs" no-gutters justify="end">
								<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
							</v-row>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import common from "../../../helper/common"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		categories: {
			type: Array,
			required: true,
		},
		case_types: {
			type: Array,
			required: true,
		},
		text: {
			type: Boolean,
			default: false,
		},
		query: {
			type: Object,
			required: true,
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			createdDateRange: [],
			createdDateRangeMenu: false,
			dialog: false,
			q: {
				case_number_cont: null,
				name_cont: null,
				case_type_eq: null,
				product_product_code_cont: null,
				product_name_cont: null,
				product_category_id_eq: null,
				product_sub_category_id_eq: null,
				created_at_gteq: null,
				created_at_lteq: null,
			},
		}
	},
	mounted() {
		this.q = this.query
	},
	methods: {
		searchProblemCases() {
			this.$emit("search-problem-cases", this.q)
			this.dialog = false
		},
		resetForm() {
			this.$refs.form.reset()
		},
		changeCategoryId() {
			this.q.product_sub_category_id_eq = null
		},
		changeDateRange(dateRange, queryName) {
			if (this[dateRange].length) {
				const firstDate = this[dateRange][0]
				const lastDate = this[dateRange][this[dateRange].length - 1]
				if (firstDate > lastDate) {
					this.q[`${queryName}_gteq`] = lastDate + "T00:00:00"
					this.q[`${queryName}_lteq`] = firstDate + "T23:59:59"
				} else {
					this.q[`${queryName}_gteq`] = firstDate + "T00:00:00"
					this.q[`${queryName}_lteq`] = lastDate + "T23:59:59"
				}
			} else {
				this.q[`${queryName}_gteq`] = null
				this.q[`${queryName}_lteq`] = null
			}
			this.$refs[`${dateRange}Menu`].save(this[dateRange])
		},
	},
	computed: {
		createdDatesText: {
			get() {
				return this.createdDateRange.length
					? this.createdDateRange.map((d) => common.formatDate(d)).join(" ~ ")
					: null
			},
			set(newVal) {
				this.createdDateRange = []
				this.changeDateRange("createdDateRange", "created_at")
				return
			},
		},
		setSubCategories() {
			const categoryId = this.q.product_category_id_eq
			if (!categoryId) {
				return []
			} else {
				const category = this.categories.find((c) => c.id == categoryId)
				if (!category) return []
				return category.product_sub_categories
			}
		},
	},
	watch: {
		query: {
			handler(val) {
				this.q = val
			},
			deep: true,
		},
	},
}
</script>